jQuery(document).ready(function() {

  document.querySelectorAll('.listing-words').forEach((list) => {
    const words = list.querySelectorAll('li');
    let current = 0;

    setInterval(() => {
      words[current].classList.remove('is-active');
      current = (current + 1) % words.length;
      words[current].classList.add('is-active');
    }, 2000);
  });


  // COLOUR ACCESSIBILITY

  document.querySelectorAll('.tag[data-bg-color]').forEach((tag) => {
    const hex = tag.dataset.bgColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
    tag.style.color = luminance < 150 ? '#ffffff' : '#242424';
  });

  document.querySelectorAll('.block[data-bg-color]').forEach((block) => {
    const hex = block.dataset.bgColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
    const contrastColor = luminance < 150 ? '#ffffff' : '#242424';
    block.style.setProperty('--contrast-color', contrastColor);
  });


  // HOMEPAGE BANNER EFFECT

  const body = document.body;
  if (body.classList.contains('is-home')) {
    window.addEventListener('wheel', (event) => {
      const scrollTop =
        document.scrollingElement
          ? document.scrollingElement.scrollTop
          : window.scrollY;
      if (
        event.deltaY > 0 &&
        !body.classList.contains('is-scrolled')
      ) {
        event.preventDefault();
        body.classList.add('is-scrolled');
        return;
      }
      if (
        event.deltaY < 0 &&
        scrollTop <= 10
      ) {
        body.classList.remove('is-scrolled');
      }
    }, {
      passive: false
    });
    window.addEventListener('click', () => {
      if (!body.classList.contains('is-scrolled')) {
        body.classList.add('is-scrolled');
      }
    });
    const banner = document.querySelector('.wrapper-banner-home');
    if (banner) {
      const bannerStartTop = banner.getBoundingClientRect().top;
      function updateNavState() {
        const currentTop = banner.getBoundingClientRect().top;
        const scrolledDistance = bannerStartTop - currentTop;
        body.classList.toggle(
          'hide-nav',
          scrolledDistance > window.innerHeight * 1
        );
      }
      window.addEventListener(
        'scroll',
        updateNavState,
        {
          passive: true
        }
      );
      document.addEventListener(
        'scroll',
        updateNavState,
        {
          capture: true,
          passive: true
        }
      );
      updateNavState();
    }
  }

  // OPEN/CLOSE NAV

  const header = document.querySelector('.header');
  const menu = document.querySelector('.goodstock-header__menu');
  const button = document.querySelector('.goodstock-header__menu-button');
  if (header && menu && button) {
    button.addEventListener('click', () => {
      requestAnimationFrame(() => {
        header.classList.toggle('open', menu.open);
      });
    });
  }


  // PAGE TRANSITION

  const headerLogo = document.querySelector('.header .logo');
  const headerSection = document.querySelector('.header-section');
  if (headerLogo && headerSection) {
    headerLogo.addEventListener('click', (event) => {
      event.preventDefault();

      const url = headerLogo.href;

      headerSection.classList.add('is-clicked');
      document.body.classList.add('is-page-leaving');

      setTimeout(() => {
        window.location.href = url;
      }, 350);
    });
  }



  // ANCHOR NAV - HIDE AT FAQ

  const anchorNav = document.querySelector('.wrapper-nav-anchors');
  const faqSection = document.querySelector('.wrapper-faq');
  console.log('Anchor nav:', anchorNav);
  console.log('FAQ section:', faqSection);
  if (anchorNav && faqSection) {
    function updateAnchorNav() {
      const faqTop = faqSection.getBoundingClientRect().top;
      const triggerPoint = 100;
      anchorNav.classList.toggle(
        'is-hidden',
        faqTop <= triggerPoint
      );
    }
    window.addEventListener('scroll', updateAnchorNav, {
      passive: true
    });
    document.addEventListener('scroll', updateAnchorNav, {
      capture: true,
      passive: true
    });
    window.addEventListener('resize', updateAnchorNav);
    updateAnchorNav();
  }

  document.querySelectorAll('.goodstock .product .goodstock-size-option__circle').forEach(circle => {
    if (circle.textContent.trim().length > 4) {
      circle.parentElement.style.width = 'auto';
      circle.style.width = 'auto';
      circle.style.padding = '0 10px';
      circle.style.borderRadius = '50px';
    }
  });



});
